import React, { useState } from "react";
import { ChevronDownIcon, ArchiveIcon } from "lucide-react";
import { NeedsInfoPill } from "./primitives";

// Rarely / never filled for these borrower contacts — kept collapsed and secondary.
const advancedFields: {
  label: string;
  value: string;
}[] = [{
  label: "Home Phone",
  value: ""
}, {
  label: "Other Phone",
  value: ""
}, {
  label: "Contact Status",
  value: ""
}, {
  label: "Contact Type",
  value: ""
}, {
  label: "Credit Status",
  value: ""
}, {
  label: "Middle Credit Score",
  value: ""
}, {
  label: "Employer Name",
  value: ""
}, {
  label: "Job Title / Current Position",
  value: ""
}, {
  label: "Employment Start Date",
  value: ""
}, {
  label: "Occupancy",
  value: ""
}, {
  label: "Closing Date",
  value: ""
}, {
  label: "Property State",
  value: ""
}];
export function AdvancedDrawer() {
  const [open, setOpen] = useState(false);
  return <div className="rounded-xl border border-slate-200 bg-slate-50/60" data-id="element-9" data-mp="k1xrxy4xzopa">
      <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-10" data-mp="k40o6zwoue2g">
        <span className="flex items-center gap-3" data-id="element-11" data-mp="1qmgbvmhj3hbs">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-200 text-slate-500" data-id="element-12" data-mp="24gzg83h18uwq">
            <ArchiveIcon className="h-4 w-4" data-id="element-13" data-mp="1zofrqbgt4fd5" />
          </span>
          <span data-id="element-14" data-mp="2edvg5ksv88po">
            <span className="block text-sm font-semibold text-slate-700" data-id="element-15" data-mp="2edc7kup3uwob">
              Advanced Details
            </span>
            <span className="block text-xs text-slate-400" data-id="element-16" data-mp="29eitp15wp3nm">
              Rarely used fields — expand only if needed.
            </span>
          </span>
        </span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} data-id="element-17" data-mp="2if75dp7turxc" />
      </button>
      {open && <div className="grid grid-cols-1 gap-x-6 gap-y-4 border-t border-slate-200 px-5 py-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="o27kbgkoh5io">
          {advancedFields.map(f => <div key={f.label} className="flex flex-col gap-1" data-id="element-19" data-mp="2o6a7l2cqeqil">
              <span className="text-xs font-medium text-slate-500" data-id="element-20" data-mp="2t3k411yjg2fx">
                {f.label}
              </span>
              {f.value.trim() === "" ? <NeedsInfoPill data-id="element-21" data-mp="323gjccz1foyb" /> : <span className="text-sm text-slate-700" data-id="element-22" data-mp="3251gmacqllzv">{f.value}</span>}
            </div>)}
        </div>}
    </div>;
}